var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isHelpModalShown)?_c('modal',{attrs:{"append-to-body":""},on:{"modal-close":function($event){return _vm.setIsHelpModalShown()}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("helpTitle")]},proxy:true}],null,true)},[_vm._t("help")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }